import { Injectable } from '@angular/core';
import { WindowRef } from 'src/sb-tools/typescript/services/window-ref.service';
import { HelperService } from 'src/sb-tools/typescript/services/helper.service';
import { CookieService } from 'src/sb-tools/typescript/authentication/cookie.service';
import { TicketDetailsPanelService } from '../ticket-details-panel.service';
import { AttachmentType } from 'src/sb-tools/typescript/enums/attachment-type.enum';

@Injectable({
    providedIn: 'root',
})
export class ReplyStoreService {
    constructor(
        private windowRef: WindowRef,
        private cookieService: CookieService,
        private ticketDetailsPanelService: TicketDetailsPanelService,
    ) {}

    attachmentTypeEnum = AttachmentType;
    readonly storingTime = 604800000; // week in ms
    timer;
    userSignature = '';

    tempReplyKey(ticketId?) {
        return 'ticketNewReply' + (ticketId || this.ticketDetailsPanelService.currentTicketId);
    }

    saveTempReply(reply, replyId?, ticketId?: number) {
        if (this.timer) {
            clearTimeout(this.timer);
        }

        this.timer = setTimeout(() => {
            reply.changeDate = new Date().valueOf();
            const tempReply = structuredClone(reply);
            if (this.ticketDetailsPanelService.currentTicketId) {
                setTimeout(() => {
                    const currentKey = replyId
                        ? this.tempReplyKey(ticketId) + '_' + replyId
                        : this.tempReplyKey(ticketId);
                    if (tempReply.html && !this.isSignature(tempReply.html)) {
                        const val = JSON.stringify(tempReply);

                        if (HelperService.isLocalStorageNameSupported()) {
                            this.windowRef.nativeWindow.localStorage.setItem(currentKey, val);
                        } else {
                            this.cookieService.setCookie(currentKey, val);
                        }
                    } else {
                        if (HelperService.isLocalStorageNameSupported()) {
                            this.windowRef.nativeWindow.localStorage.removeItem(currentKey);
                        } else {
                            this.cookieService.deleteCookie(currentKey);
                        }
                    }
                }, 10);
            }
        }, 300);
    }

    updateTempReplyStatus(isDisabled: boolean, ticketId: number, replyId?: number) {
        const tempReply = this.getTempReply(ticketId, replyId, true);
        if (tempReply) {
            tempReply.isDisabled = isDisabled;

            this.saveTempReply(tempReply, replyId, ticketId);
        }
    }

    getTempReply(ticketId?: number, replyId?, isIgnoreDisabledStatus?: boolean) {
        const currentKey = replyId ? this.tempReplyKey(ticketId) + '_' + replyId : this.tempReplyKey(ticketId);
        let data;

        if (HelperService.isLocalStorageNameSupported()) {
            data = this.windowRef.nativeWindow.localStorage.getItem(currentKey);
        } else {
            data = this.cookieService.getCookie(currentKey);
        }

        if (data) {
            try {
                const parsedData = JSON.parse(data);

                // if changes too old -> remove it
                if (new Date().valueOf() - parsedData.changeDate >= this.storingTime) {
                    this.clearTempReply(null);
                    return null;
                }

                if (parsedData?.isDisabled && !isIgnoreDisabledStatus) {
                    return null;
                } else {
                    return parsedData;
                }
            } catch {
                return null;
            }
        }
    }

    clearTempReply(parentReplyId, ticketId?) {
        const currentKey = parentReplyId
            ? this.tempReplyKey(ticketId) + '_' + parentReplyId
            : this.tempReplyKey(ticketId);
        if (HelperService.isLocalStorageNameSupported()) {
            this.windowRef.nativeWindow.localStorage.removeItem(currentKey);
        } else {
            this.cookieService.deleteCookie(currentKey);
        }
    }

    // todo: check this method
    clearAllReplies() {
        const replyKeys = [];
        if (HelperService.isLocalStorageNameSupported()) {
            for (let i = 0, len = this.windowRef.nativeWindow.localStorage.length; i < len; ++i) {
                if (
                    this.windowRef.nativeWindow.localStorage.key(i) &&
                    this.windowRef.nativeWindow.localStorage.key(i).indexOf('ticketNewReply') === 0
                ) {
                    replyKeys.push(this.windowRef.nativeWindow.localStorage.key(i));
                }
            }

            replyKeys.forEach((item) => {
                this.windowRef.nativeWindow.localStorage.removeItem(item);
            });
        } else {
            const theCookies = this.windowRef.nativeWindow.document.cookie.split(';');
            // let aString = '';
            for (let i = 0; i <= theCookies.length; i++) {
                // aString += i + ' ' + theCookies[i - 1] + '\n';

                if (theCookies[i] && theCookies[i].indexOf('ticketNewReply') === 0) {
                    replyKeys.push(theCookies[i]);
                }
            }

            replyKeys.forEach((item) => {
                this.cookieService.deleteCookie(item);
            });
        }
    }

    isReplyHasOnlyInlineImage(html) {
        if (html) {
            return !HelperService.strip(html).trim() && html.indexOf('<img') > -1;
        } else {
            return false;
        }
    }

    isSignature(html) {
        if (!this.userSignature) {
            return false;
        }
        const signatureElement = this.userSignature.replace(/(<([^>]+)>)/gi, '');
        const replyContent = html.replace(/(<([^>]+)>)/gi, '');
        return signatureElement === replyContent;
    }
}
